import { render, staticRenderFns } from "./c_foot.vue?vue&type=template&id=10290206&scoped=true"
import script from "./c_foot.vue?vue&type=script&lang=js"
export * from "./c_foot.vue?vue&type=script&lang=js"
import style0 from "./c_foot.vue?vue&type=style&index=0&id=10290206&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10290206",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/adam/Documents/Private_Repository/sjtx/backendAdmin/sjtx_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10290206')) {
      api.createRecord('10290206', component.options)
    } else {
      api.reload('10290206', component.options)
    }
    module.hot.accept("./c_foot.vue?vue&type=template&id=10290206&scoped=true", function () {
      api.rerender('10290206', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfigRight/c_foot.vue"
export default component.exports